/**
 * Home layouts index - exports all home layout variants
 * and provides a layout resolver function.
 */
import HomeLayoutDefault from './HomeLayoutDefault.mjs';
import HomeLayoutTopicFocus from './HomeLayoutTopicFocus.mjs';
import HomeLayoutAuthorSpotlight from './HomeLayoutAuthorSpotlight.mjs';
import HomeLayoutLongForm from './HomeLayoutLongForm.mjs';

// Layout registry - data-aware layouts
const LAYOUTS = {
    'default': HomeLayoutDefault,
    'topic-focus': HomeLayoutTopicFocus,
    'author-spotlight': HomeLayoutAuthorSpotlight,
    'long-form': HomeLayoutLongForm,
};

/**
 * Get the layout component for a given layout name
 * @param {string} layoutName - Name of the layout
 * @returns {React.Component} - Layout component (defaults to HomeLayoutDefault)
 */
export function getHomeLayout(layoutName) {
    return LAYOUTS[layoutName] || HomeLayoutDefault;
}

export {
    HomeLayoutDefault,
    HomeLayoutTopicFocus,
    HomeLayoutAuthorSpotlight,
    HomeLayoutLongForm,
    LAYOUTS
};

export default getHomeLayout;

